<template>
  <div id="app" translate="no">
    <router-view />
    <b-modal ref="modal-sm-updateSW" id="modal-sm-updateSW" header-bg-variant="warning" size="sm">
      <template #modal-title>
        <b-icon icon="arrow-up-square-fill" aria-hidden="true" font-scale="1.3" />&#160;
        <span class="titulo-modal" v-t="'nueva-version'"></span>
      </template>
      <p v-t="'por-favor-refresque-la-pagina'"></p>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="updateWindows();" variant="success">
          <b-icon-bootstrap-reboot aria-hidden="true" />&#160;{{ $t('aceptar') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script lang="ts">
const DefaultLayout = () => import('@/views/base/DefaultLayout.vue')

export default {
  components: {
    DefaultLayout,
  },
  mounted() {
    window.addEventListener("message", (e) => {
      if (e.data.msg === "SW_UPDATED") {
        this.clearCaches();
        this.$refs['modal-sm-updateSW'].toggle('#toggle-btn');
      }
    });
  },
  methods: {
    updateWindows() {
      window.location.reload();
    },
    clearCaches() {
      window.caches.keys().then(cacheNames => {
        cacheNames.forEach(cacheName => {
          window.caches.delete(cacheName);
        });
      });
    },
  },
}
</script>


<style>
:root {
  --maincolor: #2a7dff;
  --secondcolor: #eff3fb;
}

html,
body {
  background-color: var(--secondcolor);
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: Arial, Helvetica, sans-serif;
  height: 100%;
}
</style>
